module.exports = __webpack_public_path__ + "img/svg - only tv.fc80ac45.svg";